import i18n from "./i18n";
const getEnvironment = () => {
  const key = typeof process !== "undefined" && process.env.REACT_APP_API_ENV || typeof process !== "undefined" && process.env.NEXT_PUBLIC_API_ENV || "";
  switch (key) {
    case "master":
    case "production":
      return "production";
    case "playground":
    case "demo":
      return "demo";
    case "staging":
      return "staging";
    case "local":
      return "local";
    default:
      return "development";
  }
};
const env = getEnvironment();
const FALLBACK_PCA_KEY = "UA97-PP22-CG98-HT84";
const getApiUrl = (environment) => {
  switch (environment) {
    case "production":
      return `https://api.tabeo.co.uk/v1`;
    case "staging":
      return `https://staging.api.tabeo.co.uk/v1`;
    case "demo":
      return `https://demo.api.tabeo.co.uk/v1`;
    case "local":
      return `http://core.tabeo.local/v1`;
    default:
      return `https://development.api.tabeo.co.uk/v1`;
  }
};
const getStripeKey = (environment) => {
  const STRIPE_KEYS = {
    production: "pk_live_q0Z92g8ypGCZ9TRp1ikYrJPz",
    staging: "pk_test_TOSV7Y0lyJd50zQTbVoKkOXK",
    development: "pk_test_yM1hmY4bq4AOpQatSsDoaAZL",
    demo: "pk_test_waNNA0J3yUXiBnsRvjf9Cktt",
    local: "pk_test_yM1hmY4bq4AOpQatSsDoaAZL"
  };
  return STRIPE_KEYS[environment] || STRIPE_KEYS.development;
};
const defaultConfig = {
  ENV: env,
  API_URL: getApiUrl(env),
  PCA_API_KEY: FALLBACK_PCA_KEY,
  STRIPE_KEY: getStripeKey(env),
  LOCALE: "en-GB",
  COUNTRY: "gb"
};
let config = defaultConfig;
function configure(newConfig) {
  config = { ...defaultConfig, ...newConfig };
  i18n.changeLanguage(config.LOCALE);
}
const features = {
  get pcaPhoneValidation() {
    const { FEATURE_FLAGS: FF } = config;
    return FF?.pcaPhoneValidation !== false;
  },
  get pcaEmailValidation() {
    const { FEATURE_FLAGS: FF } = config;
    return FF?.pcaEmailValidation !== false;
  },
  get pcaBankValidation() {
    const { FEATURE_FLAGS: FF } = config;
    return FF?.pcaBankValidation !== false;
  },
  get pcaIbanValidation() {
    const { FEATURE_FLAGS: FF } = config;
    return FF?.pcaIbanValidation !== false;
  }
};
function getConfig() {
  return config;
}
export {
  FALLBACK_PCA_KEY,
  configure,
  features,
  getConfig
};
